module.exports = __webpack_public_path__ + "img/flower.a1f8f3f7.png";